export default __webpack_public_path__ + "static/media/baner.2a9b2207.jpg";